export const RETAIL_TYPES = [
  { key: 'neighborhood_center', text: 'Neighborhood Center' },
  { key: 'community_center', text: 'Community Center' },
  { key: 'power_center', text: 'Power Center' },
  { key: 'lifestyle_center', text: 'Lifestyle Center' },
  { key: 'outlet_center', text: 'Outlet Center' },
] as const;

export const US_STATES = [
  { key: 'AL', text: 'Alabama' },
  { key: 'AK', text: 'Alaska' },
  { key: 'AZ', text: 'Arizona' },
  { key: 'AR', text: 'Arkansas' },
  { key: 'CA', text: 'California' },
  { key: 'CO', text: 'Colorado' },
  { key: 'CT', text: 'Connecticut' },
  { key: 'DE', text: 'Delaware' },
  { key: 'FL', text: 'Florida' },
  { key: 'GA', text: 'Georgia' },
  { key: 'HI', text: 'Hawaii' },
  { key: 'ID', text: 'Idaho' },
  { key: 'IL', text: 'Illinois' },
  { key: 'IN', text: 'Indiana' },
  { key: 'IA', text: 'Iowa' },
  { key: 'KS', text: 'Kansas' },
  { key: 'KY', text: 'Kentucky' },
  { key: 'LA', text: 'Louisiana' },
  { key: 'ME', text: 'Maine' },
  { key: 'MD', text: 'Maryland' },
  { key: 'MA', text: 'Massachusetts' },
  { key: 'MI', text: 'Michigan' },
  { key: 'MN', text: 'Minnesota' },
  { key: 'MS', text: 'Mississippi' },
  { key: 'MO', text: 'Missouri' },
  { key: 'MT', text: 'Montana' },
  { key: 'NE', text: 'Nebraska' },
  { key: 'NV', text: 'Nevada' },
  { key: 'NH', text: 'New Hampshire' },
  { key: 'NJ', text: 'New Jersey' },
  { key: 'NM', text: 'New Mexico' },
  { key: 'NY', text: 'New York' },
  { key: 'NC', text: 'North Carolina' },
  { key: 'ND', text: 'North Dakota' },
  { key: 'OH', text: 'Ohio' },
  { key: 'OK', text: 'Oklahoma' },
  { key: 'OR', text: 'Oregon' },
  { key: 'PA', text: 'Pennsylvania' },
  { key: 'RI', text: 'Rhode Island' },
  { key: 'SC', text: 'South Carolina' },
  { key: 'SD', text: 'South Dakota' },
  { key: 'TN', text: 'Tennessee' },
  { key: 'TX', text: 'Texas' },
  { key: 'UT', text: 'Utah' },
  { key: 'VT', text: 'Vermont' },
  { key: 'VA', text: 'Virginia' },
  { key: 'WA', text: 'Washington' },
  { key: 'WV', text: 'West Virginia' },
  { key: 'WI', text: 'Wisconsin' },
  { key: 'WY', text: 'Wyoming' },
] as const;

export const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:8787/api';

export const ROUTES = {
  DASHBOARD: '/',
  PROJECT_DETAILS: '/project',
  CASH_FLOW: '/cash-flow',
  TENANTS: '/tenants',
  REPORTS: '/reports',
  SENSITIVITY: '/sensitivity',
  SCENARIOS: '/scenarios',
  SETTINGS: '/settings',
} as const;
